import ApiClient from '$lib/api';

const api = new ApiClient();

export function startRecordingSession(session) {
  return api.post('/api/record/start', session);
}

export function uploadRecordingChunk({ sessionId, index, blob, mimeType }) {
  return api.post('/api/record/chunk', blob, {
    headers: {
      'Content-Type': mimeType || blob.type || 'application/octet-stream',
      'x-session-id': sessionId,
      'x-chunk-index': String(index),
      'x-record-mime': mimeType || blob.type || 'video/webm'
    }
  });
}

export function finishRecordingSession({ sessionId, expectedChunks, stoppedAt }) {
  return api.post('/api/record/finish', {
    sessionId,
    expectedChunks,
    stoppedAt
  });
}
